import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { VectorBackground } from "../components/VectorBackground";
import WpImage from "../components/WpImage";

const SecuritySection = ({
    header,
    description,
    features,
    certificationText,
    certificationImages,
    certificationBadges,
    layout,
    slug,
}) => {
    const displayLayout = layout || "default";
    const cmsCertificationBadges =
        certificationImages && certificationImages.length > 0
            ? certificationImages
            : certificationBadges;

    return (
        <section className="security-section" id={slug || "security"}>
            <VectorBackground />
            <Container>
                <Row className="security-section__row">
                    <Col lg={12} className="security-section__content-col">
                        {header && (
                            <h2
                                className="security-section__header"
                                dangerouslySetInnerHTML={{ __html: header }}
                            />
                        )}
                        {description && (
                            <div
                                className="security-section__description"
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        )}
                        {cmsCertificationBadges &&
                            cmsCertificationBadges.length > 0 && (
                                <div className="security-section__cert-badges-wrapper">
                                    {cmsCertificationBadges.map(
                                        (cert, index) => (
                                            <WpImage
                                                key={index}
                                                className="security-section__cert-badge"
                                                image={cert.badge}
                                                alt={cert.badge?.altText || ""}
                                            />
                                        )
                                    )}
                                </div>
                            )}
                        {certificationText && (
                            <div className="security-section__cert-box">
                                <div
                                    className="security-section__cert-text"
                                    dangerouslySetInnerHTML={{
                                        __html: certificationText,
                                    }}
                                />
                            </div>
                        )}
                    </Col>
                    <Col lg={10} className="security-section__features-col">
                        {features &&
                            features.map((feature, index) => (
                                <div
                                    key={index}
                                    className="security-section__feature"
                                >
                                    {feature.icon && (
                                        <WpImage
                                            className="security-section__feature-icon"
                                            image={feature.icon}
                                            alt={feature.text || ""}
                                        />
                                    )}
                                    {feature.text && (
                                        <div
                                            className="security-section__feature-text"
                                            dangerouslySetInnerHTML={{
                                                __html: feature.text,
                                            }}
                                        />
                                    )}
                                </div>
                            ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default SecuritySection;
